import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    text() {
      return $(`
      <div class="lt-input">
        <div id="prepend" class="input-group__prepend"></div>
        <input id="input" type="text" class="input__inner">
        <span id="prefix" class="input__prefix">
          <i id="prefixIcon" class="input__icon"></i>
        </span>
        <span id="suffix" class="input__suffix">
          <span id="suffixInner" class="input__suffix-inner">
            <i id="suffixIcon" class="input__icon"></i>
            <i id="clearIcon" class="input__icon fa fa-times-circle input__clear"></i>
            <i id="pwdIcon" class="input__icon fa fa-eye input__clear"></i>
            <span id="count" class="input__count">
              <span id="countInner" class="input__count-inner"></span>
            </span>
          </span>
          <i id="validateIcon" class="input__icon"></i>
        </span>
        <div id="append" class="input-group__append"></div>
      </div>`)
    },
    textarea() {
      return $(`
      <div class="lt-textarea">
        <textarea id="input" class="textarea__inner"></textarea>
        <span id="count" class="input__count"></span>
      </div>`)
    },
    hidden() {
      return $(`
      <div class="lt-input">
        <input id="input" type="hidden" class="input__inner">
      </div>`)
    }
  },
  updater: {
    // 原生属性: name
    name(value, opt, tar, node) {
      const { input } = tar.members
      if (value) {
        input.attr('name', value)
      } else {
        input.attr('name', '')
      }
    },
    // 原生属性: placeholder
    placeholder(value, opt, tar, node) {
      const { input } = tar.members
      if (value) {
        input.attr('placeholder', value)
      } else {
        input.removeAttr('placeholder')
      }
    },
    // 原生属性: maxlength
    maxlength(value, opt, tar, node) {
      const { input } = tar.members
      if (value) {
        input.attr('maxlength', value)
      } else {
        input.removeAttr('maxlength')
      }
    },
    // 原生属性: minlength
    minlength(value, opt, tar, node) {
      const { input } = tar.members
      if (value) {
        input.attr('minlength', value)
      } else {
        input.removeAttr('minlength')
      }
    },
    // 原生属性: readonly
    readonly(value, opt, tar, node) {
      const { input } = tar.members
      if (value || value === '') {
        input.prop('readonly', true)
      } else {
        input.prop('readonly', false)
      }
    },
    // 原生属性: disabled
    disabled(value, opt, tar, node) {
      const { input } = tar.members
      if (value || value === '') {
        tar.unit.addClass('is-disabled')
        input.prop('disabled', true)
      } else {
        tar.unit.removeClass('is-disabled')
        input.prop('disabled', false)
      }
    },
    // 基本功能: rows
    rows(value, opt, tar, node) {
      const { type } = opt
      const { input } = tar.members
      if (type !== 'textarea') return
      if (value) {
        input.attr('rows', value)
      } else {
        input.removeAttr('rows')
      }
    },
    // 基本功能: 尺寸
    size(value, opt, tar, node) {
      value && tar.unit.removeClass('input-size--*').addClass(`input-size--${value}`)
    },
    // 基本功能: 值
    value(value, opt, tar, node) {
      const { input } = tar.members
      input.val(value)
    },
    // 扩展功能: 填写建议
    autocomplete(value, opt, tar, node) {
      const { input } = tar.members
      if (value) {
        input.removeAttr('autocomplete')
      } else {
        input.attr('autocomplete', 'off')
      }
    },
    // 扩展功能: 前置图标
    prefix(value, opt, tar, node) {
      const { prefix, prefixIcon } = tar.members
      if (!prefix) return
      if (value) {
        prefixIcon.addClass(`fa fa-${value}`)
        tar.unit.append(prefix).addClass('input--prefix')
      } else {
        tar.unit.removeClass('input--prefix')
        prefix.detach()
      }
    },
    // 扩展功能: 后置图标
    suffix(value, opt, tar, node) {
      const { suffix, suffixIcon, suffixInner } = tar.members
      if (!suffix || !suffixIcon) return
      if (value) {
        suffixIcon.addClass(`fa fa-${value}`)
        suffixInner.append(suffixIcon)
      } else {
        suffixIcon.detach()
      }
    },
    // 扩展功能: 显示当前字数
    words(value, opt, tar, node) {
      const { count } = tar.members
      if (!count) return
      const countParent = (tar.members.countParent = tar.members.countParent && count.parent())
      if (value) {
        countParent.append(count)
      } else {
        count.detach()
      }
    },
    // 扩展功能: 是否可清空
    clearable(value, opt, tar, node) {
      const { input, clearIcon } = tar.members
      if (!clearIcon) return
      clearIcon.detach()
    },
    // 扩展功能: 显示当前字数
    valid(value, opt, tar, node) {
      const { validateIcon, suffix } = tar.members
      if (!validateIcon) return
      if (value) {
        suffix.append(validateIcon)
      } else {
        validateIcon.detach()
      }
    },
    // 扩展功能: 密码显示
    pwd(value, opt, tar, node) {
      const { input, suffix, pwdIcon, suffixInner } = tar.members
      if (opt.type !== 'text') return
      if (!suffix || !pwdIcon || !suffixInner) return
      if (value) {
        suffixInner.append(pwdIcon)
        input.attr('type', 'password')
      } else {
        pwdIcon.detach()
        input.attr('type', 'text')
      }
    },
    // 扩展功能: 前置元素
    prepend(value, opt, tar, node) {
      const { input, prepend } = tar.members
      if (!prepend) return
      if (value) {
        prepend.html(value)
        input.before(prepend)
        tar.unit.addClass('input-group--prepend input-group')
      } else {
        prepend.detach()
      }
    },
    // 扩展功能: 后置元素
    append(value, opt, tar, node) {
      const { input, append } = tar.members
      if (!append) return
      if (value) {
        append.html(value)
        input.after(append)
        tar.unit.addClass('input-group--append input-group')
      } else {
        append.detach()
      }
    }
  }
}

export default class Text extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      type: 'text', // 控件类型(text/hidden/textarea/password)
      typingLock: false // 输入触发开关
    }
    this.defaults = {
      name: '', // 原生属性: 控件名
      placeholder: '', // 原生属性:占位文字
      maxlength: '', // 原生属性:字数上限
      minlength: '', // 原生属性:字数上限
      readonly: false, // 原生属性: 只读(true/false)
      disabled: false, // 原生属性: 禁用(true/false)
      autocomplete: false, // 原生属性:自填充

      size: '', // 基本功能: 尺寸
      rows: 2, // 基本功能: 行数 !textarea 有效
      value: '', // 基本功能: 值

      pwd: false, // 扩展功能: 密码开启
      words: false, // 扩展功能: 显示当前字数(true/false) !textarea/text 有效
      clearable: true, // 扩展功能: 是否可清空(true/false)
      valid: false, // 扩展功能: 校验
      prefix: '', // 扩展功能: 前置图标
      suffix: '', // 扩展功能: 后置图标
      prepend: '', // 扩展功能: 前置元素
      append: '' // 扩展功能: 后置元素
    }
    this.events = {
      change: 'onChange',
      focus: 'onFocus',
      blur: 'onBlur',
      keyup: 'onKeyup',
      input: 'onInput',
      click: 'onClick',
      mouseover: 'onMouseover',
      mouseleave: 'onMouseleave',
      erase: null
    }
    this.settings = Object.assign({}, def, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const { type } = opt
    let template
    if (type === 'text') template = util.template.text(opt, this)
    else if (type === 'textarea') template = util.template.textarea(opt, this)
    else template = util.template.hidden(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    const { clearIcon } = this.members
    this.clearAnchor = clearIcon && clearIcon.parent()
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {
    const { input, clearIcon } = this.members
    const unit = this.unit
    input.on('click', $.proxy(this.click, this))
    input.on('keyup', $.proxy(this.keyup, this))
    input.on('input', $.proxy(this.input, this))
    input.on('change', $.proxy(this.change, this))
    input.on('focus', $.proxy(this.focus, this))
    input.on('blur', $.proxy(this.blur, this))
    input.on('compositionstart', () => {
      this.typing = true
    })
    input.on('compositionend', () => {
      this.typing = false
    })
    unit.on('mouseover', $.proxy(this.mouseover, this))
    unit.on('mouseleave', $.proxy(this.mouseleave, this))
    clearIcon &&
      clearIcon.click(() => {
        this.value = ''
        this.erase()
        input.change()
      })
  }

  handleInput() {
    if (!this.typing || !this.settings.typingLock) {
      this.value = this.members.input.val().trim()
    }
  }

  onMouseover(e) {
    if (!e || !e.target) {
      this.unit.mouseover()
      return false
    }
    if (!this.clearable) return
    if (this.disabled || this.disabled === '') return
    const { clearIcon } = this.members
    if (!clearIcon) return
    const parent = this.clearAnchor
    const siblings = clearIcon.siblings()
    if (this.value) {
      parent.append(clearIcon)
      siblings.hide()
    } else {
      clearIcon.detach()
      siblings.show()
    }
  }

  onMouseleave(e) {
    if (!e || !e.target) {
      this.unit.mouseleave()
      return false
    }
    if (!this.clearable) return
    if (this.disabled || this.disabled === '') return
    const { clearIcon } = this.members
    if (!clearIcon) return
    const siblings = clearIcon.siblings()
    clearIcon.detach()
    siblings.show()
  }

  onChange(e) {
    if (!e || !e.target) {
      this.members.input.change()
      return false
    }
    this.handleInput()
  }

  onKeyup(e) {
    if (!e || !e.target) {
      this.members.input.keyup()
      return false
    }
    this.handleInput()
  }

  onInput(e) {
    if (!e || !e.target) {
      this.members.input.input()
      return false
    }
    this.handleInput()
  }

  onFocus(e) {
    if (!e || !e.target) {
      this.members.input.focus()
      return false
    }
    this.unit.addClass('is-focus')
  }

  onBlur(e) {
    if (!e || !e.target) {
      this.members.input.blur()
      return false
    }
    this.unit.removeClass('is-focus')
  }

  onClick(e) {
    if (!e || !e.target) {
      this.members.input.click()
      return false
    }
  }

  get textContent() {
    return this.value
  }
}
